import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom'; 
import HelpPages from './HelpPages';  

function Help() {
  return (
    <Routes>
      <Route path="/" element={<HelpPages />} />
      <Route path="/pages" element={<HelpPages />} />  
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default Help; 